import React from "react";
import { Link } from "react-router-dom";
import { Mail, MessageCircle, ArrowUpRight } from "lucide-react";
import { LOGO_LOCKUP, CONTACT_EMAIL, WHATSAPP_DISPLAY, WHATSAPP_URL, NAV_LINKS } from "@/lib/site-data";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative mt-24 border-t border-white/[0.06] overflow-hidden">
      <div className="absolute inset-0 pointer-events-none">
        <div
          className="absolute -top-32 left-1/2 -translate-x-1/2 w-[700px] h-[400px]"
          style={{
            background: "radial-gradient(circle, rgba(43,77,255,0.18) 0%, transparent 70%)",
            filter: "blur(60px)",
          }}
        />
      </div>
      <div className="relative max-w-7xl mx-auto px-6 pt-20 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <span className="relative inline-block h-24 md:h-32 w-[300px] md:w-[380px] overflow-hidden -ml-2">
              <img
                src={LOGO_LOCKUP}
                alt="Xyro Tech Solution"
                className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 h-[230%] w-auto max-w-none object-contain"
              />
            </span>
            <p className="mt-4 text-zinc-400 max-w-md leading-relaxed">
              AI-powered career acceleration for international students, OPT/CPT candidates, H1B professionals and IT experts targeting high-paying US roles.
            </p>
            <div className="mt-6 space-y-2 text-sm">
              <a
                href={`mailto:${CONTACT_EMAIL}`}
                className="flex items-center gap-2 text-zinc-300 hover:text-white"
                data-testid="footer-email-link"
              >
                <Mail className="w-4 h-4 text-[#5b78ff]" /> {CONTACT_EMAIL}
              </a>
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noreferrer"
                className="flex items-center gap-2 text-zinc-300 hover:text-white"
                data-testid="footer-whatsapp-link"
              >
                <MessageCircle className="w-4 h-4 text-[#25D366]" /> {WHATSAPP_DISPLAY}
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <p className="text-xs uppercase tracking-[0.2em] text-[#5b78ff] font-semibold mb-4">
              Navigate
            </p>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="text-zinc-300 hover:text-white inline-flex items-center gap-1.5 text-sm"
                  >
                    {l.label} <ArrowUpRight className="w-3.5 h-3.5 opacity-50" />
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="text-xs uppercase tracking-[0.2em] text-[#5b78ff] font-semibold mb-4">
              Ready to start?
            </p>
            <p className="text-zinc-300 text-sm mb-5 leading-relaxed">
              Book a free 30-minute career consultation. No obligations. Just a clear plan to get hired in the USA.
            </p>
            <Link
              to="/contact"
              data-testid="footer-cta"
              className="inline-flex items-center gap-2 btn-primary-xyro rounded-full px-5 py-3 text-sm font-medium"
            >
              Book Free Consultation <ArrowUpRight className="w-4 h-4" />
            </Link>
          </div>
        </div>

        <div className="hairline mt-16" />

        <div className="mt-8 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-zinc-500">
          <p>© {new Date().getFullYear()} Xyro Tech Solutions. All rights reserved.</p>
          <p>Built for ambitious careers in the United States.</p>
        </div>
      </div>
    </footer>
  );
}
